import { Fab as GSFab, AddIcon, FabLabel, FabIcon } from "@gluestack-ui/themed";

import { styles } from "./styles";
import { FabProps } from "./types";
import Spinner from "@repo/core/components/core/Spinner";

export const Fab = ({
  label,
  isLoading = false,
  isDisabled,
  ...props
}: FabProps) => {
  return (
    // Only to ignore error because gluestack no accept position: 'fixed'
    <GSFab
      {...props}
      isDisabled={isLoading || isDisabled}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      style={styles.fab as any}
    >
      {isLoading ? (
        <Spinner color="$white" size="small" mr="$2" />
      ) : (
        <FabIcon as={AddIcon} size="sm" pr="$2" />
      )}
      <FabLabel color="$white" fontSize="$lg" fontWeight={500}>
        {label}
      </FabLabel>
    </GSFab>
  );
};
